module.exports = __webpack_public_path__ + "img/svg/background-user-rankings.56a048dee2f999b1f92b1017ce1dde30.svg";